import React from 'react';

export default function Footer() {
  return (
    <footer className="w-full text-white py-5" style={{ background: 'linear-gradient(to right, #481789, #6A1786)' }}>
      <div className="max-w-7xl mx-auto px-8 text-center">
        <p className="text-sm m-0 opacity-90">
          The Portal Designed, Developed & Maintained by IT Cell, Kendriya Vidyalaya Sangathan, HQs, New Delhi
        </p>
      </div>
    </footer>
  );
}
